import type { api } from '~/libs/api';

type TripUtils = ReturnType<typeof api.useUtils>;

export const invalidateTransportQueries = (utils: TripUtils, tripId: string) =>
  Promise.all([
    utils.trip.getTransport.invalidate({ tripId }),
    utils.trip.getTransportTimes.invalidate({ tripId }),
    utils.trip.getOverview.invalidate({ tripId }),
    utils.trip.getPrice.invalidate({ tripId })
  ]);
